// import React from "react";
// export default function Footer(){
//     return(
//       <footer className="main-footer bg-cover" style={{backgroundImage: "url(assets/demo/bg/bg-17.jpg)"}}>
    // <section className="vc_row pb-50">
    //     <div className="one-row_top_divider" style={{height: "140px"}}>
    //         <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" width="100%" height="182" viewBox="0 0 1920 182" preserveAspectRatio="none">
    //             <path d="M1921.91,916.348c0.33,39.216-.34,79.431,0,118.642Q957.95,1035.5-6,1035V853c40.431,10.8,81,19.794,122.5,27.149,62.957,11.157,117.371,15.375,180.742,21.116,79.864,7.236,165.843,26.989,255.045,42.232,109.142,18.65,243.949,40.091,308.265,44.243,137.637,8.886,313.056-2.783,504.066-36.2,127.4-22.286,223.4-43.261,354.45-45.248A1569.414,1569.414,0,0,1,1921.91,916.348Z" transform="translate(0 -853)"></path>
    //         </svg>
    //     </div>

    //     <div className="container">
    //         <div className="row">
    //             <div className="lqd-column col-md-4 mb-4 mb-md-0 text-center text-md-left">
    //                 <figure>
    //                     <img src="assets/img/logo/2Docboyz153.png" alt="Creintech Solutions" />
    //                 </figure>
    //             </div>

    //             <div className="lqd-column col-md-4 text-center mb-4 mb-md-0">
    //                 <ul className="lqd-custom-menu reset-ul inline-nav font-size-14">
    //                     <li><a  target="_blank">Copyright © 2024 Novacred Pvt Ltd </a></li>
    //                     <li><a  target="_blank">Terms of Service |</a></li>
    //                     <li><a  target="_blank">Privacy Policy |</a></li>
    //                     <li><a  target="_blank">Sitemap</a></li>
    //                 </ul>
    //             </div>

    //             <div className="lqd-column col-md-4 text-md-right text-center">
    //                 <ul className="social-icon social-icon-md">
    //                     <li><a href="https://twitter.com/creintech_in" target="_blank"><i className="fa fa-twitter"></i></a></li>
    //                     <li><a href="https://www.linkedin.com/showcase/creintech-solutions-india" target="_blank"><i className="fa fa-linkedin"></i></a></li>
    //                     <li><a href="https://www.youtube.com/channel/UCns7mL2vbZGGkeK8ynPWGLQ" target="_blank"><i className="fa fa-youtube"></i></a></li>
    //                 </ul>
    //             </div>
    //         </div>
    //     </div>
    // </section>
    
// </footer>
//     );
// }


import React from "react";
import 'normalize.css';

export default function Footer() {
  return (
    <footer className="main-footer bg-cover" style={{ backgroundImage: "url(assets/demo/bg/bg-17.jpg)" }}>
      <section className="vc_row pb-50">
        <div className="one-row_top_divider" style={{ height: "140px" }}>
          <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" width="100%" height="182" viewBox="0 0 1920 182" preserveAspectRatio="none">
            <path d="M1921.91,916.348c0.33,39.216-.34,79.431,0,118.642Q957.95,1035.5-6,1035V853c40.431,10.8,81,19.794,122.5,27.149,62.957,11.157,117.371,15.375,180.742,21.116,79.864,7.236,165.843,26.989,255.045,42.232,109.142,18.65,243.949,40.091,308.265,44.243,137.637,8.886,313.056-2.783,504.066-36.2,127.4-22.286,223.4-43.261,354.45-45.248A1569.414,1569.414,0,0,1,1921.91,916.348Z" transform="translate(0 -853)"></path>
          </svg>
        </div>

        <div className="container">
          <div className="row">

            {/* Contact Details */}
            <div className="col-md-3 mb-4">
              <h4>Contact Details</h4>
              <p>Feel Free to get in touch with us</p>
              <address>
                <strong>Novacred Pvt Ltd (DocBoyz)</strong><br />
                Office no-114,<br />
                B- Wing SOHO Panchshil,<br />
                Wagholi, Pune, Maharashtra - 412207, India
              </address>
              <p>
                {/* <i className="fa fa-phone"></i> +91-20-46767345<br /> */}
                <i className="fa fa-phone"></i> +91 8470067555<br />
                <i className="fa fa-envelope"></i> info@docboyz.in<br />
                <i className="fa fa-mobile"></i> Get the App
              </p>
            </div>

            {/* Our Services */}
            <div className="col-md-3 mb-4">
              <h4>Our Services</h4>
              <ul className="list-unstyled">
                <li>DB Document Collection</li>
                <li>DB Debt Recovery</li>
                <li>Reg Tech API</li>
                <li>e-Nach/e-Mandate</li>
                <li>Multi Tenant</li>
                <li>Bank Account Verification</li>
                <li>Verified Customer Acquisition</li>
                <li>Vehicle Verification</li>
              </ul>
            </div>

            {/* Postman & API */}
            <div className="col-md-3 mb-4">
            {/* <Link to="/Regtech"> */}
             <h4>Postman & API</h4> 
              <ul className="list-unstyled">
                <li>Customer Verification</li>
                <li>E-Kyc</li>
                <li>Video KYC</li>
                <li>E-Sign</li>
                <li>Offline Aadhar</li>
                <li>Aadhar Masking</li>
                <li>DB Fmatch</li>
              </ul>
            </div>

            {/* Quick Links */}
            <div className="col-md-3 mb-4">
              <h4>Quick Links</h4>
              <ul className="list-unstyled">
                <li>Privacy Policy</li>
                <li>About Us</li>
                <li>Blog</li>
                <li>Careers</li>
                <li>Contact Us</li>
                <li>Media</li>
                <li>Industries We Serve</li>
              </ul>
            </div>

          </div>
        </div>
        {/*  */}
        <div className="container">
            <div className="row">
                <div className="lqd-column col-md-4 mb-4 mb-md-0 text-center text-md-left">
                    <figure>
                        {/* <img src="assets/img/logo/2Docboyz153.png" alt="Creintech Solutions" /> */}
                        <span className="navbar-brand-inner">
                                        <h1 style={{ fontSize: '3em', fontWeight: 'bold' }}>
                                          <span style={{ color: 'red', fontWeight: 'bold' }}>Doc</span>
                                          <span style={{ color: 'white', fontWeight: 'bold' }}>Boyz</span>
                                        </h1>
                                        </span>
                    </figure>
                </div>

                <div className="lqd-column col-md-4 text-center mb-4 mb-md-0">
                    <ul className="lqd-custom-menu reset-ul inline-nav font-size-14">
                        <li><a  target="_blank">Copyright © 2024 Novacred Pvt Ltd </a></li>
                        <li><a  target="_blank">Terms of Service |</a></li>
                        <li><a  target="_blank">Privacy Policy |</a></li>
                        <li><a  target="_blank">Sitemap</a></li>
                    </ul>
                </div>

                <div className="lqd-column col-md-4 text-md-right text-center">
                    <ul className="social-icon social-icon-md">
                        <li><a  target="_blank"><i className="fa fa-twitter"></i></a></li>
                        <li><a  target="_blank"><i className="fa fa-linkedin"></i></a></li>
                        <li><a  target="_blank"><i className="fa fa-youtube"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
      </section>

      {/*  */}

   
    </footer>
  );
}
